import React from 'react';
import { func, array } from 'prop-types';
import useStyles from 'hooks/useStyles';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';

import { GET_TAG_CATEGORY } from '../../constants';

import styles from './TagSelector.scss';

const TagSelector = ({ tagsInfo, onChange }) => {
  useStyles(styles);
  const { t } = useTranslation(['rating']);

  return (
    <div className={styles.root}>
      {tagsInfo.map(({ key, selected }, index) => (
        <button
          type="button"
          key={key}
          className={cx(styles.item, {
            [styles.selected]: selected,
          })}
          onClick={() => onChange(index)}
        >
          {t(GET_TAG_CATEGORY(key))}
        </button>
      ))}
    </div>
  );
};

TagSelector.propTypes = {
  tagsInfo: array.isRequired,
  onChange: func.isRequired,
};

export default TagSelector;
